// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"63688a71038ed9d8","3026":"691937752b5a7690"}[chunkId] + ".css";
};